import { Component, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { mergeMap } from 'rxjs/operators';
import { ConstantMan } from '../../../../core/services/constantMan';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { User } from '../../../../core/models/user';
import { IntegrationInvite } from '../../../../core/models/integrationInvite';

interface TwitterRequestTokenResponse {
  oauth_token: string;
  oauth_token_secret: string;
  oauth_callback_confirmed: boolean;
}

@Component({
  selector: 'twitter',
  templateUrl: './twitter.component.html',
  styleUrls: ['./twitter.component.scss']
})
export class TwitterComponent implements OnInit, OnDestroy {
  public accounts: any[];
  public adAccount: any;
  public hasIntegration = false;
  loading: boolean;
  disconnectOnDestroy = false;
  oauthToken = '';
  existingIntegrations = [];
  createdIntegration: any = {};
  creating = false;
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  noAccounts = false;
  isAdmin = false;
  emitter: EventEmitter<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TwitterComponent>,
    private integrationDao: IntegrationDao
  ) {
    this.existingIntegrations = this.data.existingIntegrations;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    this.emitter = this.data.emitter;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
      this.noAccounts = true;
    }
    // this.integrationDao.generateTwitterRequestToken(this.data.brand).subscribe(
    //   (res: TwitterRequestTokenResponse) => {
    //     this.oauthToken = res.oauth_token;
    //   },
    //   err => console.error(err)
    // );
  }

  ngOnInit() {}

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  addAnother(e) {
    this.creating = true;
  }

  addAccount(e) {
    let account = this.accounts.find(acct => acct.id === this.adAccount);
    const updates = {
      accountId: this.adAccount,
      type: 'twitter',
      enabled: true,
      friendlyName: account.name
    };
    // this.integrationDao.update(this.createdIntegration.id, updates).subscribe(res => {
    //   this.disconnectOnDestroy = false;
    //   this.dialogRef.close(res);
    // });
  }

  login(e) {
    if (!this.oauthToken) {
      console.error('OAuth URL not loaded');
      return false;
    }
    let opened = window.open(
      ConstantMan.TWITTER_OAUTH_URL + this.oauthToken + '&state=' + this.data.brand,
      null,
      'width=800,height=800,menubar=0,toolbar=0,location=0,personalbar=0,statusbar=0,top=100,left=100,alwaysRaised=yes'
    );

    let listener = event => {
      if (event.data) {
        if (event.data.type && event.data.type === 'twitter' && event.data.id !== undefined) {
          this.loading = true;
          this.disconnectOnDestroy = true;
          this.integrationDao
              .loadById(event.data.id)
              .pipe(
                  // mergeMap(res => {
                  //   this.createdIntegration = res;
                  //   // return this.integrationDao.loadTwitterAccounts(this.createdIntegration.id);
                  // })
              )
              .subscribe(accounts => {
                this.hasIntegration = true;
                this.accounts = accounts;
                this.loading = false;
              });

          // remove listener
          window.removeEventListener('message', listener);

          // close window
          opened.close();
        }
      }
    }

    window.addEventListener('message', listener);
  }

  ngOnDestroy() {
    if (this.disconnectOnDestroy) {
      // this.integrationDao.disconnect(this.createdIntegration.id).subscribe(() => {
      //   console.log('successfully removed integration');
      // });
    }
  }
}
